import { EventDocument } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/types';

export const toEventDocument = (
	file: { id: string; name: string } | null | undefined
): EventDocument | undefined => (file ? { fileName: file.name, fileId: file.id } : undefined);
